import { render, staticRenderFns } from "./OnboardingFifthQuestion.vue?vue&type=template&id=13ec3081"
import script from "./OnboardingFifthQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingFifthQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports